/* Press page (page.media). Rebuilt 2026-10-22: reveal on scroll, the sticky chapter nav's active
   state, copy buttons that only say "Copied" when the clipboard accepted the text (otherwise a
   box to copy by hand), a share link that keeps the preview parameters, tabs ([data-tabs]), the
   image library's filters, "Show all" and real downloads, and print (one-sheet). No dependencies. */
(function () {
  if (!document.querySelector('.ss-press') && !(window.Shopify && window.Shopify.designMode)) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // reveal
  var io = ('IntersectionObserver' in window && !reduce) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }) : null;
  function initReveal(root) {
    root.querySelectorAll('[data-reveal]').forEach(function (el) {
      if (el.dataset.revealBound) return;
      el.dataset.revealBound = '1';
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  // sticky nav active state
  var links = [], targets = [];
  function initNav() {
    links = Array.prototype.slice.call(document.querySelectorAll('.ss-press-nav a[href^="#"]'));
    targets = links.map(function (a) { return document.querySelector(a.getAttribute('href')); });
  }
  function setActive() {
    var y = window.scrollY + window.innerHeight * 0.35, current = null;
    targets.forEach(function (t) { if (t && t.getBoundingClientRect().top + window.scrollY <= y) current = t; });
    links.forEach(function (a, i) {
      var on = targets[i] === current;
      if (on && !a.classList.contains('is-active')) { var ul = a.closest('ul'); if (ul) ul.scrollTo({ left: a.offsetLeft - 20, behavior: reduce ? 'auto' : 'smooth' }); }
      a.classList.toggle('is-active', on);
    });
  }
  window.addEventListener('scroll', setActive, { passive: true });

  // chapter nav: the bar gets its glass only once it sticks under the header
  function setStuck() {
    var nav = document.querySelector('.ss-press-nav');
    var wrap = nav && nav.parentElement;
    if (!wrap) return;
    var top = parseFloat(getComputedStyle(wrap).top) || 0;
    wrap.classList.toggle('is-stuck', wrap.getBoundingClientRect().top <= top + 1 && window.scrollY > 0);
  }
  window.addEventListener('scroll', setStuck, { passive: true });
  window.addEventListener('resize', setStuck);

  // copy: success only when the clipboard took it; otherwise a box to copy by hand
  function flash(btn, text, state) {
    var label = btn.querySelector('[data-label]');
    if (btn._t) { clearTimeout(btn._t); if (label && label.dataset.was) label.textContent = label.dataset.was; }
    btn.setAttribute('data-copied', state);
    if (label) { label.dataset.was = label.textContent; label.textContent = text; }
    btn._t = setTimeout(function () { btn.removeAttribute('data-copied'); if (label) label.textContent = label.dataset.was; btn._t = null; }, 1800);
  }
  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    var ok = false; try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }
  var box = null;
  function manualCopy(text) {
    if (!box) {
      box = document.createElement('div');
      box.className = 'ss-press-copybox'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-label', 'Copy');
      box.innerHTML = '<p></p><textarea readonly></textarea><button type="button" class="ss-press__btn ss-press__btn--sm">Done</button>';
      box.querySelector('button').addEventListener('click', function () { box.hidden = true; });
      box.addEventListener('keydown', function (e) { if (e.key === 'Escape') box.hidden = true; });
      document.body.appendChild(box);
    }
    box.querySelector('p').textContent = /Mac|iPhone|iPad/.test(navigator.platform) ? 'Press ⌘C to copy, or select the text.' : 'Press Ctrl+C to copy, or select the text.';
    var ta = box.querySelector('textarea');
    ta.value = text; box.hidden = false; ta.focus(); ta.select();
  }
  function copyText(text, btn) {
    var ok = function () { flash(btn, 'Copied', 'true'); };
    var fail = function () { if (legacyCopy(text)) ok(); else { flash(btn, 'Copy by hand', 'failed'); manualCopy(text); } };
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) navigator.clipboard.writeText(text).then(ok, fail);
    else fail();
  }
  // the link to share: this address without the hash and tracking, keeping the page and preview parameters
  function shareUrl() {
    var u = new URL(location.href), keep = ['view', 'preview_theme_id'], out = new URL(u.origin + u.pathname);
    keep.forEach(function (k) { if (u.searchParams.get(k)) out.searchParams.set(k, u.searchParams.get(k)); });
    return out.toString();
  }

  // email links: the mail app opens as usual, and the address is copied too, since many editors have no
  // mail app set up (webmail) and a mailto then does nothing
  var toast = null;
  function note(text) {
    if (!toast) {
      toast = document.createElement('p');
      toast.className = 'ss-press-toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = text; toast.classList.add('is-on');
    clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 4500);
  }
  function copyMail(a) {
    var addr = decodeURIComponent(a.getAttribute('href').slice(7).split('?')[0]);
    if (!addr) return;
    var ok = function () { note(addr + ' copied. If no email app opened, paste it into your email.'); };
    var fail = function () { if (legacyCopy(addr)) ok(); else note('Email us at ' + addr); };
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) navigator.clipboard.writeText(addr).then(ok, fail);
    else fail();
  }

  // downloads: same-origin files download through the attribute; CDN files are fetched and saved, else opened
  function download(a) {
    var url = a.href, name = a.getAttribute('download') || url.split('?')[0].split('/').pop();
    if (new URL(url, location.href).origin === location.origin) return false;
    var label = a.querySelector('[data-label]'), was = label ? label.textContent : '';
    if (label) label.textContent = 'Preparing';
    fetch(url, { mode: 'cors' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.blob(); }).then(function (blob) {
      var obj = URL.createObjectURL(blob), tmp = document.createElement('a');
      tmp.href = obj; tmp.download = name; document.body.appendChild(tmp); tmp.click(); tmp.remove();
      setTimeout(function () { URL.revokeObjectURL(obj); }, 4000);
      if (label) label.textContent = was;
    }).catch(function () { if (label) label.textContent = was; window.open(url, '_blank', 'noopener'); });
    return true;
  }

  // print: open every details, load every lazy image (hidden tabs included), then print
  function preparePrint() {
    document.querySelectorAll('.ss-press details').forEach(function (d) { d.open = true; });
    var waits = [];
    document.querySelectorAll('.ss-press img').forEach(function (img) {
      img.loading = 'eager';
      if (!img.complete) waits.push(new Promise(function (r) { img.addEventListener('load', r, { once: true }); img.addEventListener('error', r, { once: true }); }));
    });
    return Promise.race([Promise.all(waits), new Promise(function (r) { setTimeout(r, 2500); })]);
  }
  window.addEventListener('beforeprint', function () { document.querySelectorAll('.ss-press details').forEach(function (d) { d.open = true; }); });

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    var mail = t.closest('.ss-press a[href^="mailto:"]');
    if (mail) { copyMail(mail); return; }
    var copy = t.closest('.ss-press [data-copy]');
    if (copy) { copyText(copy.getAttribute('data-copy'), copy); return; }
    var link = t.closest('.ss-press [data-copy-link]');
    if (link) { ev.preventDefault(); copyText(link.getAttribute('data-copy-link') || shareUrl(), link); return; }
    var dl = t.closest('.ss-press [data-download]');
    if (dl && download(dl)) { ev.preventDefault(); return; }
    var print = t.closest('.ss-press [data-print]');
    if (print) { ev.preventDefault(); preparePrint().then(function () { window.print(); }); }
  });

  // tabs
  function initTabs(root) {
  root.querySelectorAll('[data-tabs]').forEach(function (c) {
    if (c.dataset.tabsBound) return;
    c.dataset.tabsBound = '1';
    var tabs = Array.prototype.slice.call(c.querySelectorAll('[role="tab"]'));
    function select(i, focus) {
      tabs.forEach(function (x, j) {
        var on = i === j, panel = document.getElementById(x.getAttribute('aria-controls'));
        x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1;
        if (panel) panel.classList.toggle('is-active', on);
      });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % tabs.length, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + tabs.length) % tabs.length, true); }
      });
    });
  });

  }

  // image library: filter chips and Show all
  function initBoards(root) {
  root.querySelectorAll('[data-board]').forEach(function (b) {
    if (b.dataset.boardBound) return;
    b.dataset.boardBound = '1';
    var tiles = Array.prototype.slice.call(b.querySelectorAll('.ss-press-tile'));
    var chips = Array.prototype.slice.call(b.querySelectorAll('[data-filter]'));
    var more = b.querySelector('[data-board-more]');
    var base = more ? more.textContent.trim() : '';
    var limit = window.innerWidth < 750 ? 8 : (parseInt(b.getAttribute('data-initial'), 10) || 12), all = false, cat = 'all';
    function render() {
      var shown = 0, matching = 0;
      tiles.forEach(function (el) {
        var match = cat === 'all' || el.getAttribute('data-cat') === cat;
        if (match) matching++;
        var show = match && (all || cat !== 'all' || shown < limit);
        if (show) shown++;
        el.hidden = !show;
      });
      if (more) { more.hidden = all || cat !== 'all' || matching <= limit; more.textContent = base + ' (' + matching + ')'; }
    }
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        cat = ch.getAttribute('data-filter');
        chips.forEach(function (x) { x.setAttribute('aria-pressed', String(x === ch)); });
        render();
      });
    });
    if (more) more.addEventListener('click', function () { all = true; render(); });
    render();
  });
  }

  // run once for the page, and again for a section the theme editor reloads
  function init(root) { initReveal(root); initTabs(root); initBoards(root); initNav(); setActive(); setStuck(); }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector('.ss-press, .ss-press-nav')) init(e.target); else initNav(); });
  document.addEventListener('shopify:section:unload', function () { setTimeout(initNav, 0); });
})();
